import React from "react";
import s from "../../style/home.module.less";

const ITEMS = [
  "Your keys stay in your wallet",
  "Fees shown before you sign",
  "Devnet + Mainnet",
  "Open source",
];

export const Marquee = () => (
  <div className={s.marquee}>
    <div className={s.marqueeRow}>
      {ITEMS.map((item, i) => (
        <React.Fragment key={item}>
          {i > 0 && <span className={s.marqueeDot}>·</span>}
          <span className={s.marqueeItem}>{item}</span>
        </React.Fragment>
      ))}
    </div>
  </div>
);
